namespace GeniuzPOS.Inventory {
    export interface IcStockWhsForm {
        SkuCode: Serenity.StringEditor;
        SkuWhsIdCode: Serenity.StringEditor;
        QtyOnhand: Serenity.DecimalEditor;
        StockCostValue: Serenity.DecimalEditor;
    }

    export class IcStockWhsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockWhs';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockWhsForm.init)  {
                IcStockWhsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(IcStockWhsForm, [
                    'SkuCode', w0,
                    'SkuWhsIdCode', w0,
                    'QtyOnhand', w1,
                    'StockCostValue', w1
                ]);
            }
        }
    }
}
